function StatsGrid({ items }) {
    const visible = (items || []).filter((item) => item.show !== false);
    if (visible.length === 0) return null;

    return (
        <div className="flex flex-col md:flex-row md:flex-wrap mt-8 gap-6">
            {visible.map((item, i) => (
                <div key={i} className="flex-1 min-w-[10rem] text-center">
                    <div className="text-3xl text-golden font-bold">{item.bolded}</div>
                    <div className="text-1xl">{item.text}</div>
                </div>
            ))}
        </div>
    );
}

export default StatsGrid;
